import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { appManageTypes, consentStatuses } from "../../../consts";
import { consentsService } from "../../../services";

export const useValidateMarketConsents = () => {
  const [marketsWithoutConsents, setMarketsWithoutConsents] = useState([]);

  const selectedApp = useSelector((store) => store.apps?.selectedApp);
  const markets = useSelector((store) => store.markets?.markets) ?? [];
  const manageType = useSelector((store) => store.apps.manageType);
  const isMarketsReassigned = useSelector((store) => store.apps?.isMarketsReassigned);

  const appMarkets = useMemo(() => {
    if (selectedApp.marketConfigs) {
      const selectedAppMarkets = selectedApp.marketConfigs.map((market) => market.market);

      return markets.filter((market) => selectedAppMarkets.includes(market.market));
    }

    return [];
  }, [selectedApp, markets]);

  const validateMarketsConsents = async () => {
    const marketsConsents = await Promise.all(
      appMarkets.map(async (market) => {
        return {
          market: market.market,
          consents: await consentsService.fetchConsents(market.market, selectedApp.appType)
        };
      })
    );

    setMarketsWithoutConsents(
      marketsConsents
        .filter(
          (market) => !market.consents.some((consent) => consent.status === consentStatuses.active)
        )
        .map((market) => market.market)
    );
  };

  useEffect(() => {
    if (
      (manageType === appManageTypes.FROM_EXISTING && isMarketsReassigned) ||
      manageType !== appManageTypes.FROM_EXISTING
    ) {
      validateMarketsConsents();
    }
  }, [appMarkets.length, manageType, isMarketsReassigned]);

  return marketsWithoutConsents;
};
